import NotificationManager from "../../common/notification/NotificationManager";
import { formatMessage } from "./LanguageHelper";
import { DEFAULT_IMAGE_EXTENSION, DEFAULT_IMAGE_RESOLUTION_MAP } from "../../components/coobjects/ImageDropdown";
import { DocumentPartMetadata } from "../../api/models/document-part-metadata";

export const restoreDefaultDocumentMetadata = (
  documentId: string,
  showNotification: boolean = true
): DocumentPartMetadata => {
  console.error(`No documentPartMetadata has been retrieved for document ${documentId}`);

  if (showNotification) {
    NotificationManager.addNotification({
      title: "",
      message: formatMessage("cof.editdocument.message.metadatanotfound"),
      type: "warning",
      isTemporary: false,
    });
  }

  return {
    documentId: documentId,
    formatMetadata: defaultFormatMetadata(),
    formatImage: defaultFormatImage(),
    parametersMetadata: [],
    inheritableParametersMetadata: [],
    templateInfo: null,
  };
};

const defaultFormatMetadata = () => {
  return {
    numberFormatValue: "37", //#,##0;-#,##0
    numberType: "Default",
    percentageFormatValue: "10", //0.00%
    percentageType: "Default",
    dateFormatValue: "14", //m/d/yy
    dateType: "Default",
    locale: null,
  };
};

const defaultFormatImage = () => {
  return {
    imageExtension: DEFAULT_IMAGE_EXTENSION,
    imageResolution: DEFAULT_IMAGE_RESOLUTION_MAP.get(DEFAULT_IMAGE_EXTENSION),
  };
};
